import React from 'react';

type FeaturedRoundIconProps = React.SVGProps<SVGSVGElement>;

export const FeaturedRoundIcon: React.FC<FeaturedRoundIconProps> = (props) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#F6EFFF" />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9F5FF" strokeWidth="8" />
    <path
      d="M29 18L19 30H28L27 38L37 26H28L29 18Z"
      stroke="#6941C6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

FeaturedRoundIcon.displayName = 'FeaturedRoundIcon';

export default FeaturedRoundIcon;
